const disputeClaimsPT = {
    "view": {
        "table": {
            "title": "Suas Infrações de Direitos Autorais",
            "columns": {
                "release": "Lançamento",
                "user": "Usuário",
                "store": "Loja",
                "claimantName": "Nome do Reclamante",
                "claimantEmail": "Email do Reclamante",
                "resolutionTime": "Tempo de Resolução",
                "remainingTime": "Tempo Restante",
                "status": "Status"
            },
            "label": {
                "status_created": "Criado",
                "status_pending": "Pendente",
                "status_in_progress": "Em Progresso",
                "status_resolved": "Resolvido",
                "status_copyright_violation": "Violação de Direitos Autorais"
            },
            "button": {
                "exportCSV": "Exportar CSV"
            },
            "placeholder": {
                "search": "Pesquisar..."
            }
        }
    }
};

export default disputeClaimsPT;